import React from 'react';
import { ShieldCheck, Gauge, Clock } from 'lucide-react';
export function TrustBar() {
  return <section className="bg-dark py-12 border-t border-white/10 relative z-20" data-id="element-260" data-mp="1c0notwn0teei">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261" data-mp="y8ph9q8yjqkg">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 divide-y md:divide-y-0 md:divide-x divide-white/10" data-id="element-262" data-mp="yak79iz368ve">
          <div className="flex items-start space-x-4 pt-6 md:pt-0 md:px-6 first:pt-0 first:pl-0" data-id="element-263" data-mp="1qxep084iqu56">
            <div className="flex-shrink-0" data-id="element-264" data-mp="1uyzx7g63yk91">
              <ShieldCheck className="w-10 h-10 text-orange" data-id="element-265" data-mp="1uxym5bp3dxrb" />
            </div>
            <div data-id="element-266" data-mp="1gzqi6jtn1w6n">
              <h3 className="text-xl font-display tracking-wide text-white mb-1" data-id="element-267" data-mp="1gy5osxj28jad">
                DEALER ALTERNATIVE
              </h3>
              <p className="text-slate-400 text-sm" data-id="element-268" data-mp="1m0egzro3zhbf">
                Why pay dealership prices?
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4 pt-6 md:pt-0 md:px-6" data-id="element-269" data-mp="ajer12p8hekk">
            <div className="flex-shrink-0" data-id="element-270" data-mp="1ainfxps3wdk2">
              <Gauge className="w-10 h-10 text-orange" data-id="element-271" data-mp="1ajosjyort83w" />
            </div>
            <div data-id="element-272" data-mp="16i3j6nbg3byg">
              <h3 className="text-xl font-display tracking-wide text-white mb-1" data-id="element-273" data-mp="16in2a7cu06e2">
                ADVANCED DIAGNOSTICS
              </h3>
              <p className="text-slate-400 text-sm" data-id="element-274" data-mp="1keqgir7b844w">
                Fixing the problem, not the symptoms.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4 pt-6 md:pt-0 md:px-6" data-id="element-275" data-mp="1tgq1fulg3sd4">
            <div className="flex-shrink-0" data-id="element-276" data-mp="1pgpmm8ufpf5j">
              <Clock className="w-10 h-10 text-orange" data-id="element-277" data-mp="1pfxp2sha17cm" />
            </div>
            <div data-id="element-278" data-mp="236jd0vll87hd">
              <h3 className="text-xl font-display tracking-wide text-white mb-1" data-id="element-279" data-mp="2372pvxwds5oj">
                FAST TURNAROUND
              </h3>
              <p className="text-slate-400 text-sm" data-id="element-280" data-mp="2d5s157trurvt">
                Getting you back on the road, fast.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}